import { render, staticRenderFns } from "./Collectibles.vue?vue&type=template&id=399e9db9&scoped=true&"
import script from "./Collectibles.vue?vue&type=script&lang=js&"
export * from "./Collectibles.vue?vue&type=script&lang=js&"
import style0 from "./Collectibles.vue?vue&type=style&index=0&id=399e9db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399e9db9",
  null
  
)

export default component.exports